import InvoicesIndex from "./InvoicesIndex";
export default InvoicesIndex;
